module.exports = __webpack_public_path__ + "img/invByBatFlow.47279ec9.gif";